import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const POSTS = [
  {
    slug: "tigers-nest-paro",
    title: "A Quiet Morning at Tiger's Nest",
    excerpt:
      "Before the prayer flags fully wake, the monastery breathes a slow rhythm — and so does the traveller who arrives at dawn.",
    image:
      "https://images.pexels.com/photos/35197058/pexels-photo-35197058.jpeg?auto=compress&cs=tinysrgb&w=1600",
    place: "Paro, Bhutan",
    date: "Jan 2026",
  },
  {
    slug: "block-printers-bagru",
    title: "The Block-Printers of Bagru",
    excerpt:
      "Four generations of indigo, madder and pomegranate. An afternoon of inks, hands, and the weight of unbroken practice.",
    image: "https://indiorajourneys.com/images/India6.jpg",
    place: "Rajasthan, India",
    date: "Dec 2025",
  },
  {
    slug: "slow-train-nuwara-eliya",
    title: "Up the Hill on the Slow Train",
    excerpt:
      "An ode to Sri Lanka's central highlands — and to the architecture of a tea estate visited just before monsoon.",
    image: "https://indiorajourneys.com/images/Srilanka3.jpg",
    place: "Nuwara Eliya, Sri Lanka",
    date: "Nov 2025",
  },
  {
    slug: "kathmandu-thangka-studio",
    title: "Letters from a Kathmandu Studio",
    excerpt:
      "A thangka painter, his teacher, and the long quiet labour of devotional art in a courtyard where time refuses to hurry.",
    image: "https://indiorajourneys.com/images/Nepal2.jpg",
    place: "Patan, Nepal",
    date: "Oct 2025",
  },
];

export default function Journal() {
  return (
    <main className="bg-ivory text-ink">
      <section className="pt-40 md:pt-52 pb-24 max-w-[1480px] mx-auto px-6 md:px-12">
        <div className="eyebrow mb-8">
          The Journal
        </div>
        <h1 className="font-serif text-6xl md:text-[8rem] leading-[0.92] tracking-tighter font-light">
          Field notes <br />
          <em className="italic text-indigo_deep">from the road.</em>
        </h1>
        <p className="mt-12 max-w-2xl text-lg text-ink/70 font-light leading-relaxed">
          Quiet observations, slow essays, and small portraits of place —
          written from the road by our curators and the artisans we hold dear.
        </p>
      </section>

      <section className="pb-32 max-w-[1480px] mx-auto px-6 md:px-12 grid grid-cols-12 gap-x-6 gap-y-20">
        {POSTS.map((p, i) => (
          <article
            key={p.slug}
            className={`group col-span-12 md:col-span-6 ${i % 2 === 1 ? "md:mt-24" : ""}`}
          >
            <div className="img-zoom overflow-hidden aspect-[4/5]">
              <img src={p.image} alt={p.title} className="w-full h-full object-cover" />
            </div>
            <div className="mt-8 flex items-center justify-between text-[10px] tracking-widest3 uppercase text-ink/55">
              <span>{p.place}</span>
              <span>{p.date}</span>
            </div>
            <h2 className="mt-4 font-serif text-3xl md:text-4xl font-light leading-tight group-hover:text-indigo_deep transition-colors">
              {p.title}
            </h2>
            <p className="mt-4 text-ink/70 font-light leading-relaxed max-w-lg">
              {p.excerpt}
            </p>
            <Link
              to="/contact"
              className="mt-6 inline-flex items-center gap-2 text-[10px] tracking-widest2 uppercase font-semibold border-b border-ink pb-1 hover:text-terracotta hover:border-terracotta transition-colors"
            >
              Read the field note
              <ArrowUpRight size={14} />
            </Link>
          </article>
        ))}
      </section>
    </main>
  );
}
